import React from "react";
import Header from "../components/Header.";
import InputSection from "../components/InputSection";
import PreviewSection from "../components/PreviewSection";
import { useSelector } from "react-redux";

const HomePage = () => {
  const selector = useSelector((state) => state.flightApp);
  return (
    <>
      <Header />
      <section>
        {/* Input data sections */}
        <InputSection />
        {/* Preview data sections */}
        {selector.length !== 0 && <PreviewSection />}
      </section>
    </>
  );
};

export default HomePage;
